import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
abstract class SymbolBehaviourDriver {

    public symbolId: string;

    protected proxy: SymbolBehaviourDriver;

    private behaviours: AbstractSymbolBehaviour[] = [];

    public addBehaviour(behaviour: AbstractSymbolBehaviour) {
        this.behaviours.push(behaviour);
    }

    public removeBehaviour(behaviour: AbstractSymbolBehaviour) {
        for (let i = this.behaviours.length; i >= 0; i--) {
            if (this.behaviours[i] === behaviour) {
                this.behaviours.splice(i, 1);
            }
        }
    }

    /**
     * Sometimes a symbol should not handle it's own behaviours, and instead
     * a proxy takes over. For example with a stack symbol
     */
    public setProxy(proxy: SymbolBehaviourDriver) {
        this.proxy = proxy;
    }

    public executeBehaviour(method: SymbolBehaviourMethod, ...args: any[]): Contract<void> {

        if (this.proxy) {
            return this.proxy.executeBehaviour(method, ...args);
        }

        const methods = [];

        for (const behaviour of this.behaviours) {

            let behaviourActive = true;

            if (behaviour.validSymbols) {
                behaviourActive = false;

                for (const validSymbol of behaviour.validSymbols) {

                    if (this.symbolId === validSymbol) {
                        behaviourActive = true;
                        break;
                    }
                }
            }

            if (behaviourActive) {
                // TODO: Convert this to map lookups
                if (method === SymbolBehaviourMethod.Static) {
                    behaviour.static(...args);
                } else if (method === SymbolBehaviourMethod.Stick) {
                    behaviour.stick(...args);
                } else if (method === SymbolBehaviourMethod.Land) {
                    methods.push(() => behaviour.land(...args));
                } else if (method === SymbolBehaviourMethod.Highlight) {
                    methods.push(() => behaviour.highlight(...args));
                } else if (method === SymbolBehaviourMethod.Win) {
                    methods.push(() => behaviour.win(...args));
                } else if (method === SymbolBehaviourMethod.Cycle) {
                    methods.push(() => behaviour.cycle(...args));
                } else if (method === SymbolBehaviourMethod.SymbolChange) {
                    behaviour.changeSymbol(...args);
                } else if (method === SymbolBehaviourMethod.UpdateTransform) {
                    behaviour.updateTransform(...args);
                } else if (method === SymbolBehaviourMethod.Dim) {
                    methods.push(() => behaviour.dim(...args));
                } else if (method === SymbolBehaviourMethod.Expand) {
                    methods.push(() => behaviour.expand(...args));
                } else if (method === SymbolBehaviourMethod.Anticipate) {
                    methods.push(() => behaviour.anticipate(...args));
                } else if (method === SymbolBehaviourMethod.Stop) {
                    methods.push(() => behaviour.stop(...args));
                } else if(method === SymbolBehaviourMethod.Display) {
                    methods.push(() => behaviour.display(...args));
                }
            }
        }

        if (!methods.length) {
            return Contract.empty();
        } else {
            return parallel(methods);
        }
    }
}

export enum SymbolBehaviourMethod {
    Static,
    Land,
    Highlight,
    Win,
    Cycle,
    SymbolChange,
    UpdateTransform,
    Dim,
    Expand,
    Anticipate,
    Stick,
    Stop, 
    Display
}

export default SymbolBehaviourDriver;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/symbol-behaviour-driver.ts